import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { wegDe } from '@/app/components/search/styles/colors.ts';
import { BaseBadgeContainer } from '../BaseBadge/styled';

const ToWegdeStyled = styled(BaseBadgeContainer)`
  background-color: ${wegDe};
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
`;

const ToWegdeBadge = () => {
  const { t } = useTranslation();
  return <ToWegdeStyled dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.weg_de_label') }} />;
};

export default ToWegdeBadge;
